/* global modForm modUtils Modalytics */
import {
	getPhoneNumberType,
	mapDynamicServiceCode
} from '../../helpers';
import { serviceCodesAndAttributions } from './serviceCodesAndAttributions';

/**
 * This function processes form attribution data, setting important values like tracking params and response format type
 * @param {Object} formData - form data
 * @returns {Object} formatted form data
 */
export function preprocessQSFormData(formData) {
	let formattedData = {};
	const form = modForm.opts.form;
	const qsFieldsTranslation = {
			FN: 'firstName',
			LN: 'lastName',
			HP: 'homePhone',
			EM: 'email',
			S1: 'address',
			CT: 'city',
			SP: 'state',
			PC: 'zip',
			OwnHome: 'homeowner',
			leadid_token: 'leadToken', // eslint-disable-line camelcase
			TrustedFormToken: 'xxTrustedFormToken'
		},
		modFieldsToRemove = [
			'session',
			'sessionToken',
			'usid',
			'landingPage',
			'tcpa',
			'tcpaText',
			'xxTrustedFormToken',
			'xxTrustedFormCertUrl',
			'inertZip',
			'homeowner',
			'zip1'
		];

	const quadLinkParams = modForm.opts.quadLinkParams;

	// If we have parameters from the quadlink request we add these to the form data
	if (Object.keys(quadLinkParams).length !== 0) {
		for (const param in quadLinkParams) {
			if (quadLinkParams.hasOwnProperty(param)) { // eslint-disable-line no-prototype-builtins
				formattedData[param] = quadLinkParams[param];
			}
		}
	} else if (modUtils.getUrlParamsToObject().hasOwnProperty('tagID')) { // eslint-disable-line no-prototype-builtins
		const { tagID } = modUtils.getUrlParamsToObject();
		formattedData.tagID = tagID;
	} else {
		formattedData.tagID = modUtils.getEnv() === 'production' ? modForm.opts.tagIDLive : modForm.opts.tagIDTest;
	}

	// Checking CROTag values and Multiple Windows to change NumberOfWindows
	if (formData.CROTag && typeof formData.CROTag !== 'undefined') {
		const croTagData = JSON.parse(formData.CROTag);

		if (croTagData.MultipleWindows && croTagData.MultipleWindows === 'Yes' && formData.NumberOfWindows === '1') {
			formData.NumberOfWindows = '3-5';
		}
	}

	// Setting campaign data if there is an active test (e.g. GrowthBook)
	if (window.activeCampaignData) {
		formattedData.TestID = window.activeCampaignData['Test ID'];
		formattedData.VariationName = window.activeCampaignData['Variation Name'];
	}

	// Setting Heap Session ID
	if (modUtils.heapCookie) {
		formattedData.HeapSessionID = modUtils.heapCookieData.sessionId;
	}

	formattedData.HeapIdentity = window.heap?.identity || 'No Heap Identity';

	// Translating our form fields name to Quinstreet nomenclature
	Object.keys(qsFieldsTranslation).forEach(function(key) {
		if (formData[qsFieldsTranslation[key]]) {
			formattedData[key] = formData[qsFieldsTranslation[key]];
			delete formData[qsFieldsTranslation[key]];
		}
	});

	// Dynamically setting the correct Service / Vertical
	formData.service = mapDynamicServiceCode(formData);

	// Remove homebuddyAttributes from CROTag to avoid duplicates with serviceSpecificAttributes
	if (formData.CROTag && typeof formData.CROTag !== 'undefined') {
		let croTagData;

		try {
			croTagData = JSON.parse(formData.CROTag);
		} catch (e) {
			croTagData = null;
		}

		if (croTagData) {
			const croTagKeys = Object.keys(croTagData);

			const matchedHomebuddyAttributions = serviceCodesAndAttributions.find(entry =>
				entry.serviceCodes.includes(formData.service)
				&& entry.homebuddyAttributes?.some(attr => croTagKeys.includes(attr))
			);

			if (matchedHomebuddyAttributions) {
				matchedHomebuddyAttributions.homebuddyAttributes.forEach(attr => {
					delete croTagData[attr];
				});

				if (Object.keys(croTagData).length) {
					formData.CROTag = JSON.stringify(croTagData);
				} else {
					delete formData.CROTag;
				}
			}
		}
	}

	// Remove unnecessary fields (for now we're doing it this way, will look for a better way in the future)
	modFieldsToRemove.forEach(function(field) {
		delete formData[field];
	});

	// Submit Consent Capture
	const brandedConsentCapture = form.querySelectorAll('[data-branded-consent]');
	const vendors = [];
	if (brandedConsentCapture && brandedConsentCapture.length) {
		// finding the visible branded consent particularly for Lead Widget (could have multiple hidden elements)
		const isVisible = brandedConsent => brandedConsent.offsetWidth > 0 && brandedConsent.offsetHeight > 0;
		const visibleBrandedConsentName = Array.from(brandedConsentCapture).find(isVisible);

		vendors.push({
			vendorKey: formData.Match,
			vendorDisplayName: visibleBrandedConsentName?.textContent
		});
		modForm.opts.consentCaptureVendors = vendors;
	}

	if (modForm.opts.gettingLiveConsent && !modForm.opts.consentRequestId) {
		Modalytics.heap('track', ['Consent Searches | Not Available on Form Submit']);
	}

	// Pass on any other fields that are still in formData
	formattedData = Object.assign(formattedData, formData);

	// Predefined values
	const path = window.location.pathname !== '/' ? window.location.pathname : '';
	formattedData.site = window.location.host.replace(/(qa|staging|www)./g, '') + path;
	formattedData.siteName = formattedData.site;
	formattedData.HomePhoneType = getPhoneNumberType(formattedData.HP.replace(/\D/g, ''));
	formattedData.HomePhoneConsent = 'Yes';
	formattedData.responseFormat = 'json';

	if (modForm.opts.ipAddress) {
		formattedData.IPAddress = modForm.opts.ipAddress;
	}

	return formattedData;
}
